import React from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import actions from "../../Redux Store/actions";
import cssClasses from "./CancellationBankDetails.module.css";
import { Box, Tooltip, Typography } from "@mui/material";
import ServerPaginationGrid from "../../Components/ServerPaginationGrid";
import { useState } from "react";
import {
  getAllCancellationBankDetails,
  updateBankRecordStatus,
} from "../../Services/Bank";
import { errorTost, successTost } from "../../Services/Toast";
import { dismissLoader, presentLoader } from "../../Services/loader";
import Button from "../../Subcomponents/Button";
import ViewBankDetailsModal from "./ViewBankDetailsModal";
import EmptyState from "../../Assets/Images/Common/noProjectFound.svg";
import LeadStatusChip from "../../Subcomponents/LeadStatusChip";
import Dot from "../../Components/Icons/Dot";
import SearchBar from "../../Subcomponents/Search";
import { debounce } from "lodash";
import { useRef } from "react";
import { DataGrid } from "@mui/x-data-grid";

const dataGridStyles = {
  "&.MuiDataGrid-root .MuiDataGrid-cell:focus": {
    outline: "none",
  },
  border: "1px solid #EAECF0 !important",
  fontWeight: "400",
  fontSize: "1.4rem",
  lineHeight: "2rem",
  color: "#667085",
  fontFamily: "Inter-Medium",
  borderRadius: "8px",
  '& div[data-colindex="1"]': {
    color: "#101828",
    fontWeight: "500",
  },
  "& .MuiDataGrid-virtualScrollerRenderZone": {
    "& .MuiDataGrid-row": {
      borderBottom: "1px solid #EAECF0",
      background: "#FFFFFF",
      /* Shadow/xl */

      // boxShadow: "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
      borderRadius: "1rem",

      //   "&:nth-of-type(2n+1)": { backgroundColor: "rgba(249, 250, 251, 1)" },
      //   backgroundColor: "#FFFFFF",
    },
    "& .MuiDataGrid-row.Mui-selected:hover": {
      borderBottom: "1px solid #EAECF0",
      backgroundColor: "#FFFFFF",
      // "&:nth-of-type(2n+1)": {
      //   backgroundColor: "rgba(249, 250, 251, 1)",
      // },
    },
  },
  "& .MuiDataGrid-iconSeparator ": {
    display: "none",
  },
  "& .MuiDataGrid-columnHeader:hover": {
    "& .MuiDataGrid-menuIcon": {
      visibility: "hidden",
    },
  },
  "& .MuiDataGrid-columnHeaders + div": {
    height: "calc(100vh - 290px) !important",
  },
  "&  .MuiDataGrid-columnHeaders": {
    background: "#F9FAFB",
    /* Gray/200 */
    border: "1px solid #EAECF0",
    /* Shadow/xl */
    // boxShadow:
    //   "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
    // borderRadius: "8px",

    marginBottom: "1rem",
    borderBottom: "6px solid #EAECF0",
  },
  "& .MuiDataGrid-columnSeparator": {
    display: "none",
  },
  "& .MuiDataGrid-checkboxInput": {
    "& svg": {
      width: "2rem",
      height: "2rem",
      background: "#FFFFFF",
    },
  },
  // "& .MuiTablePagination-displayedRows": {
  //   display: "none",
  // },
  "& .MuiDataGrid-footerContainer": {
    "& .MuiTablePagination-displayedRows ": {
      display: "none",
    },
    "& .MuiDataGrid-selectedRowCount": {
      visibility: "hidden ",
    },
  },
  "&  [title='Sort']": {
    //visibility:"hidden",
    display: "none",
    cursor: "none",
  },
  "& [title='Go to previous page']": {
    borderRadius: "0",
    border: "1px solid #EAECF0",
    borderRadius: "0.8rem",
    marginRight: "0.5rem",
  },
  "& [title='Go to next page']": {
    borderRadius: "0",
    border: "1px solid #EAECF0",
    borderRadius: "0.8rem",
    marginRight: "0.5rem",
  },
  "& [title='Go to previous page']:after": {
    content: "'Previous'",
    marginLeft: "1rem",
  },
  "& [title='Go to next page']:before": {
    content: "'Next'",
    marginRight: "1rem",
  },
  "& .MuiDataGrid-columnHeader": {
    padding: "0 4rem",

    "&:focus": {
      outline: "none",
    },
  },
  "&  .MuiDataGrid-row ": {
    maxHeight: "72px !important",
    minHeight: "72px !important",
  },
  "& .MuiDataGrid-cell": {
    padding: "0 4rem",
    minHeight: "72px !important",
    maxHeight: "72px !important",
    "&:focus": {
      outline: "none",
    },
  },
  "& .MuiButtonBase-root": {
    fontSize: "1.6rem",
  },
  "& .MuiDataGrid-cell:focus-within": {
    outline: "none !important",
  },
  "& .MuiDataGrid-cell": {
    padding: "0 2rem",
    minHeight: "72px !important",
    maxHeight: "72px !important",
    "&:focus": {
      outline: "none",
    },
  },
  "& .MuiDataGrid-columnHeader": {
    padding: "0 1rem",

    "&:focus": {
      outline: "none",
    },
  },
};

const CancellationBankDetails = () => {
  const [allCancellationBankDetails, setAllCancellationBankDetails] = useState(
    []
  );
  const [selectedBankDetails, setSelectedBankDetails] = useState();
  const [showViewDetailsModal, setShowViewDetailsModal] = useState(false);
  const dispatch = useDispatch();
  const searchValue = useRef("");
  const [pageMaintain, setPageMaintain] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [pageSize, setPageSize] = useState(12);

  const tagGridColumns = [
    {
      field: "action",
      headerName: "",
      width: 200,
      renderCell: (params) => {
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "3rem",
            }}
            className={cssClasses.actionDiv}
          >
            <div>
              <Button
                btnName={"View Details"}
                style={{
                  borderRadius: "5px",
                  backgroundColor: "#FFFFFF",
                  color: "rgb(52, 64, 84)",
                  fontSize: "1.4rem",
                }}
                padding={"0.5rem 1rem"}
                iconPosition={"left"}
                clicked={() => {
                  setSelectedBankDetails(params.row);
                  setShowViewDetailsModal(true);
                }}
              />
            </div>
          </div>
        );
      },
    },
    {
      field: "panNumber",
      headerName: "Pan Number",
      width: 220,
      renderCell: (params) => {
        return <div>{params?.row?.panNumber}</div>;
      },
    },
    {
      field: "accountHolderName",
      headerName: "Account Holder Name",
      width: 300,
      renderCell: (params) => {
        return (
          <Tooltip
            className={cssClasses.Tooltip}
            placement="bottom-start"
            title={
              <div style={{ fontSize: "1.4rem" }}>
                <p>{params.row?.customerBankDetails?.accHolderName}</p>
              </div>
            }
          >
            <div style={{ whiteSpace: "normal", lineBreak: "anywhere" }}>
              {params.row?.customerBankDetails?.accHolderName}
            </div>
          </Tooltip>
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      width: 200,
      renderCell: (params) => {
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "3rem",
            }}
            className={cssClasses.actionDiv}
          >
            {params?.row?.status === "pending" ? (
              <LeadStatusChip
                label={params?.row?.status}
                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                style={{
                  color: "rgb(181, 71, 8)",
                  backgroundColor: "rgb(255, 250, 235)",
                }}
              ></LeadStatusChip>
            ) : params?.row?.status === "accepted" ? (
              <LeadStatusChip
                label={params?.row?.status}
                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                style={{
                  color: "rgb(2, 122, 72)",
                  backgroundColor: "rgb(236, 253, 243)",
                }}
              ></LeadStatusChip>
            ) : (
              <LeadStatusChip
                label={params?.row?.status}
                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                style={{
                  color: "rgb(192, 16, 72)",
                  backgroundColor: "rgb(255, 241, 243)",
                }}
              ></LeadStatusChip>
            )}
          </div>
        );
      },
    },
    {
      field: "updateApplicationLedger",
      headerName: "Update Application Ledger",
      width: 250,
      renderCell: (params) => {
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "3rem",
            }}
            className={cssClasses.actionDiv}
          >
            {params?.row?.RefundFormUpdateLedgerResp?.length > 0 &&
            params?.row?.RefundFormUpdateLedgerResp?.filter(
              (val) => val.applicationLedgerRes
            )?.length > 0 ? (
              <LeadStatusChip
                label={"Done"}
                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                style={{
                  color: "rgb(2, 122, 72)",
                  backgroundColor: "rgb(236, 253, 243)",
                }}
              ></LeadStatusChip>
            ) : (
              <LeadStatusChip
                label={"Not Done"}
                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                style={{
                  color: "rgb(192, 16, 72)",
                  backgroundColor: "rgb(255, 241, 243)",
                }}
              ></LeadStatusChip>
            )}
          </div>
        );
      },
    },
    {
      field: "updateCustomerLedger",
      headerName: "Update Customer Ledger",
      width: 250,
      renderCell: (params) => {
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "3rem",
            }}
            className={cssClasses.actionDiv}
          >
            {params?.row?.RefundFormUpdateLedgerResp?.length > 0 &&
            params?.row?.RefundFormUpdateLedgerResp?.filter(
              (val) => val.customerLedgerRes
            )?.length > 0 ? (
              <LeadStatusChip
                label={"Done"}
                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                style={{
                  color: "rgb(2, 122, 72)",
                  backgroundColor: "rgb(236, 253, 243)",
                }}
              ></LeadStatusChip>
            ) : (
              <LeadStatusChip
                label={"Not Done"}
                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                style={{
                  color: "rgb(192, 16, 72)",
                  backgroundColor: "rgb(255, 241, 243)",
                }}
              ></LeadStatusChip>
            )}
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    dispatch(actions.activeMenu("cancellationbankdetails"));
    getBankDetailsPagination(0, searchValue.current);
  }, []);

  useEffect(() => {
    if (
      allCancellationBankDetails?.length === 0 &&
      searchValue?.current === ""
    ) {
      getBankDetailsPagination(0, searchValue.current);
    }
  }, [allCancellationBankDetails]);

  function getMoreData(passPageNumber) {
    setPageNumber(passPageNumber);
    getBankDetailsPagination(passPageNumber, searchValue.current);
  }

  async function getBankDetailsPagination(pageNumber, searchValue) {
    presentLoader();
    getAllCancellationBankDetails(
      pageNumber * pageSize,
      pageNumber * pageSize + pageSize - 1,
      searchValue
    )
      .then((getAllCancellationBankDetailsResponse) => {
        setTotalCount(getAllCancellationBankDetailsResponse.count);
        setAllCancellationBankDetails(
          getAllCancellationBankDetailsResponse?.data
        );
        dismissLoader();
        //setFilterOpen(false);
      })
      .catch((err) => {
        if (err?.message) {
          errorTost(err?.message);
        } else {
          errorTost("Something went wrong! Try again");
        }
      });
  }

  const debouncedFetchSearchData = useRef(
    debounce((e) => {
      searchValue.current = e.target.value;
      getBankDetailsPagination(0, searchValue?.current);
      // if(searchValue.current) {

      // } else {

      // }
    }, 800)
  ).current;

  return (
    <div className={cssClasses.wrapperPage}>
      <Box className={cssClasses.headerWrapper}>
        <Box className={cssClasses.headerLeftSide}>
          <Box display={"flex"} flexDirection={"column"} gap={"1rem"}>
            <Typography className={cssClasses.headerTittle}>
              Cancellation Bank Details
            </Typography>
          </Box>
        </Box>
      </Box>
      <div className={cssClasses.mainWrapper}>
        <div className={cssClasses.searchBar}>
          <SearchBar
            width="335px"
            sxStyle={{
              "& input": {
                fontSize: "1.2rem !important",
              },
            }}
            placeholder={"Search by Pan Number Or Account Holder Name"}
            search={debouncedFetchSearchData}
            id={"tagPendingCrmAllotmentLeadName"}
          />
        </div>
        {allCancellationBankDetails?.length > 0 ? (
          <DataGrid
            rows={allCancellationBankDetails}
            columns={tagGridColumns}
            pageSize={10}
            rowsPerPageOptions={[10]}
            page={pageMaintain}
            onPageChange={(_page) => {
              setPageMaintain(_page);
              if (pageNumber < _page) {
                getMoreData(_page);
              }
            }}
            sx={[dataGridStyles]}
          />
        ) : (
          <div style={{ height: "100%" }}>
            <p
              style={{
                position: "absolute",
                left: "50%",
                top: "50%",
                transform: "translateY(-50%)",
                textAlign: "center",
                fontSize: "3rem",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <img src={EmptyState} alt="No Data" />
                <span>No Record Available</span>
              </div>
            </p>
          </div>
        )}
      </div>
      {showViewDetailsModal && (
        <ViewBankDetailsModal
          open={showViewDetailsModal}
          handleClose={(isClosed) => {
            if (isClosed) {
              searchValue.current = "";
              setSelectedBankDetails();
              setAllCancellationBankDetails([]);
            }
            setShowViewDetailsModal(false);
          }}
          selectedBankDetails={selectedBankDetails}
        />
      )}
    </div>
  );
};

export default CancellationBankDetails;
